import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 31" width="1em" height="1em">
    <g data-name="Layer 2">
      <g
        data-name="Layer 1"
        stroke="fj-icons-primary-color"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="fj-icons-bg-color"
      >
        <rect
          x={5.5}
          y={-4.5}
          width={30}
          height={40}
          rx={1}
          ry={1}
          transform="rotate(90 20.5 15.5)"
        />
        <path d="M8.65 5.09h22.62M3.16 5.09H5.5M34.94 5.07h3.22M8.65 8.82h22.62M3.16 8.82H5.5M34.94 8.8h3.22M8.65 12.55h22.62M3.16 12.55H5.5M34.94 12.53h3.22M5.09 23.44h15M5.09 19.8h15M5.09 27.07h15M31.81 22.04v6.5l2.83-3.25 2.83 3.25v-6.5h-5.66z" />
        <circle cx={34.64} cy={19.8} r={3.77} />
      </g>
    </g>
  </svg>
);

const LicenseDetails = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default LicenseDetails;
